/**
 * AssetCompletionDot — at-a-glance rollup of how complete a package's
 * auto-generated assets are. Used in the Content Engine list view so
 * admins can spot packages that still need manual touch-ups without
 * clicking into each one.
 *
 * Tiers (computed server-side, see backend `_compute_asset_completion`):
 *   • green  → 10–11 / 11 shipped
 *   • amber  → 7–9 / 11 shipped
 *   • red    → 0–6 / 11 shipped
 *
 * Hover the dot to see which slots are missing.
 */
const TIER_STYLE = {
    green: {
        dot: "bg-[color:var(--bl-teal,#1b6e6e)]",
        ring: "ring-2 ring-[color:var(--bl-teal-tint,#d6ecec)]",
        label: "All assets shipped",
    },
    amber: {
        dot: "bg-[color:var(--bl-amber,#c98a2e)]",
        ring: "ring-2 ring-[color:var(--bl-amber-tint,#fbe9d1)]",
        label: "Partial — review",
    },
    red: {
        dot: "bg-[color:var(--bl-rust,#a8462a)]",
        ring: "ring-2 ring-[color:var(--bl-rust-tint,#f4d8cd)]",
        label: "Needs auto-gen",
    },
};

export default function AssetCompletionDot({ completion }) {
    if (!completion) {
        // Older packages predate the rollup field — render an unobtrusive
        // muted dot instead of an empty cell.
        return (
            <span
                className="inline-flex items-center gap-2 text-xs text-bl-muted"
                data-testid="asset-dot-unknown"
            >
                <span className="h-2 w-2 rounded-full bg-bl-muted/40" />
                —
            </span>
        );
    }
    const style = TIER_STYLE[completion.tier] || TIER_STYLE.red;
    const missingTitle =
        completion.missing && completion.missing.length > 0
            ? `Missing: ${completion.missing.join(", ")}`
            : "All 11 assets present.";
    return (
        <span
            className="inline-flex items-center gap-2 text-xs text-bl"
            title={`${style.label} (${completion.completed}/${completion.total} · ${completion.pct}%)\n${missingTitle}`}
            data-testid={`asset-dot-${completion.tier}`}
            data-completion={`${completion.completed}/${completion.total}`}
        >
            <span className={`h-2.5 w-2.5 rounded-full ${style.dot} ${style.ring}`} />
            <span className="tnum font-medium">
                {completion.completed}/{completion.total}
            </span>
        </span>
    );
}
